import { z } from 'zod'

// A scheduled task the agent drafted. `workflow_id` and `cron` are both
// required, which is what keeps this from colliding with the schemas around it —
// no other card carries either. `timezone` rides along because starting the
// schedule resends the whole cadence: the API overwrites cron and timezone
// together, and rejects an enable that arrives without them.
export const automationCardSchema = z.object({
  workflow_id: z.string(),
  cron: z.string(),
  timezone: z.string().optional(),
  title: z.string().optional(),
  goal: z.string().optional(),
  // `draft` is saved but not running. `invalid` means it could not be saved at
  // all — surfaced rather than dropped, so a failed request is visible instead
  // of looking like a schedule that quietly never fires.
  status: z.enum(['draft', 'invalid']).catch('draft'),
  error: z.string().optional(),
})
